'use client'

import { UsersIcon } from '@phosphor-icons/react'
import { MultiSelectProperty } from '@/ui/property-fields'
import type { Person } from './types'

interface PeopleSelectorProps {
  selectedPeople: Person[]
  availablePeople: Person[]
  onAddPerson: (person: Person) => void
  onRemovePerson: (person: Person) => void
  onAddNewPerson?: () => void
  isLoading?: boolean
  disabled?: boolean
}

/**
 * People selector for associating people with media entries
 */
export function PeopleSelector({
  selectedPeople,
  availablePeople,
  onAddPerson,
  onRemovePerson,
  onAddNewPerson,
  isLoading = false,
  disabled = false,
}: PeopleSelectorProps) {
  return (
    <div className="flex items-center gap-2 border-t px-3 py-2">
      <MultiSelectProperty
        label="With"
        Icon={UsersIcon}
        selectedItems={selectedPeople}
        availableItems={availablePeople}
        onAdd={onAddPerson}
        onRemove={onRemovePerson}
        getItemLabel={(p) => p.title}
        disabled={disabled}
        isLoading={isLoading}
        onAddNew={onAddNewPerson}
        addNewLabel="Add new..."
      />
    </div>
  )
}
